import script from "./PartnerReportRejectForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerReportRejectForm.vue?vue&type=script&setup=true&lang=js"

import "./PartnerReportRejectForm.vue?vue&type=style&index=0&id=4dcb1146&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dcb1146"]])

export default __exports__